module.exports = __webpack_public_path__ + "static/img/bg_logo@3x.439e828.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/bg_logo@3x.png
// module id = 36Hr
// module chunks = 1